export const getBlogPostCategories = (blogsQuerry) => {
  const categoriesArr = blogsQuerry.allMarkdownRemark.edges
    .map((post) => post.node.frontmatter.postCategories[0].frontmatter.postCategoryName)
    .sort();

  return ['All', ...new Set(categoriesArr)];
};
